<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline" @keydown.native.enter="$emit('search', formInline)">
      <el-form-item label="运单号">
        <el-input maxlength='450' v-model="formInline.expressNo" placeholder="运单号" @change="$emit('search', formInline)"></el-input>
      </el-form-item>
      <el-form-item label="签收类型">
        <el-select v-model="formInline.systemSource" placeholder="来源" @change="$emit('search', formInline)">
          <el-option label="全部" :value="''"></el-option>
          <el-option label="D2C" :value="1"></el-option>
          <el-option label="B2B" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="签收时间">
        <el-date-picker
            v-model="date"
            @change="dateChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-left: 30px" type="primary" @click="$emit('search', formInline)">搜索</el-button>
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="margin:0 0 10px 0">
      <el-button type="primary" @click="exportQuery">导出</el-button>
      <el-button type="primary" style="margin:0 10px" @click="exportDay">导出昨日</el-button>
      <el-button type="primary" style="margin:0 10px" @click="exportWeek">导出上周</el-button>
    </div>
  </div>
</template>

<script>
import {signExport,exportLastWeek,exportLastDay} from '@/apis/inventoryDetails'
export default {
  name: "From",
  data() {
    return {
      formInline: {},
      date: null
    }
  },
  mounted() {
    this.$emit('search', this.formInline)
  },
  methods: {
    dateChange: function (date) {
      // console.log(val)
      if (!date) {
        this.date = null
        this.formInline.createTimeBegin = undefined
        this.formInline.createTimeEnd = undefined
        return
      }
      this.formInline.createTimeBegin = formatDate(date[0].getTime());
      this.formInline.createTimeEnd = formatDate(date[1].getTime());


      function formatDate(value){
        let date = new Date(value); 
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      };
    },
    rest: function () {
      this.formInline = {}
      this.date = null
      this.$emit('search', this.formInline)
    },
    exportQuery(){
      signExport(this.formInline).then(({code,data})=>{
        if(code == 0){
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    },
    yesterdayTimestamp(num = 1) {
      const MillisecondsADay = 24 * 60 * 60 * num
      //  今日零点时间戳
      const timestamp = Math.floor(new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000)
      // 昨日开始时间戳
      const yesterdayStartTime = timestamp - MillisecondsADay
      // 昨日结束时间戳
      const yesterdayEndTime = timestamp - 1
      return [yesterdayStartTime, yesterdayEndTime]
    },
    exportDay(){
      exportLastDay().then(({code,data})=>{
        if(code == 0){
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    },
    exportWeek(){
      exportLastWeek().then(({code,data})=>{
        if(code == 0){
          this.$message.success('请前往报表-数据导出中下载表格')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>